import React, { useState } from "react";

const GuiaDocente = ({ children }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="accordion guia-docente" id="accordionExample">
      <div className="accordion-item">
        <h4 className="accordion-header" id="headingOne">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
            onClick={() => setShow(!show)}
          >
            GUÍA PARA EL DOCENTE O ACOMPAÑANTE
          </button>
        </h4>
        <div
          id="collapseOne"
          className={`accordion-collapse collapse ${show ? "show" : null}`}
          aria-labelledby="headingOne"
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default GuiaDocente;
